module.exports = __webpack_public_path__ + "img/cgv.e77fa83f.jpg";